import { connect } from "react-redux";
import HandOver from "./handOver";
import { bindActionCreators } from "redux";
import {
  getHandOver,
  getGateInfo,
  postHandOver,
} from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  handOverData: state.handOverReducer.handOverData,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHandOver,
      getGateInfo,
      documentUploadUrl,
      postHandOver,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HandOver);
